import useNotificationHandler from "hooks/useNotificationHandler";
import { QUERY_KEYS } from "library/shared";
import { ITaxonomy } from "library/types";
import { UseQueryResult, useQuery } from "react-query";
import api from "service/api";

const getTaxonomies = async () => {
  const response = await api.get(`/taxonomy`);

  return response.data;
};

export function useGetTaxonomies(enabled = true): UseQueryResult<ITaxonomy> {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();

  return useQuery<ITaxonomy, Error>([QUERY_KEYS.taxonomies], getTaxonomies, {
    enabled: enabled,
    onError: (error: any) => {
      handleAddAxiosErrorNotification(error);
    },
  });
}
